import { Modal as ModalModule } from 'common';
import PropTypes from 'prop-types';
import React from 'react';

const { Modal, ModalButtonActionType } = ModalModule;

const ErrorRefundModal = ({ modalId, data: { onClickLearnMore } }) => (
	<Modal
		modalId={modalId}
		className="history-refund error-refund-modal error-modal"
		header="Refund Error"
		primaryButton={{
			text: 'Close',
			type: ModalButtonActionType.Ok,
			dataqa: 'error-refund-close-button',
		}}
		secondaryButton={{
			text: 'Learn More',
			type: ModalButtonActionType.Ok,
			onClick: onClickLearnMore,
			dataqa: 'error-refund-learn-more-button',
		}}
	>
		<div className="error-modal-body">
			<p>Selected print(s) are ineligible for a refund.</p>
			<p>To learn more about refund eligibility rules, click Learn More.</p>
		</div>
	</Modal>
);

ErrorRefundModal.propTypes = {
	data: PropTypes.shape({
		onClickLearnMore: PropTypes.func.isRequired,
	}),
};

export default ErrorRefundModal;
